import React from 'react'
import WhoWeAre from '../../components/User/About/WhoWeAre'
import HeroBanner from '../../components/User/common/HeroBanner'
import WhyChooseUs from '../../components/User/About/WhyChooseUs'
import Mision from '../../components/User/About/Mision'

const About = () => {
  return (
    <div>
      <HeroBanner subheading='Home / About Us'/>
      <WhoWeAre/>
      <Mision/>
      <WhyChooseUs/>
    </div>
  )
}

export default About
